import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { useNavigate } from '@frontend/weave-router';
import { theme } from '@frontend/theme';
import { Heading, Text } from '@frontend/design-system';
import { TRAINING_LINK } from '../../constants';
import { OnboardingDashboardTrackingIds } from '../../tracking-ids';
import { DarkButton } from '../dark-button';

export const TasksCompletedNavigation = () => {
  const { t } = useTranslation('onboardingDashboard');
  const navigate = useNavigate();
  return (
    <div css={[styles.container, { padding: theme.spacing(5, 0), gap: theme.spacing(3) }]}>
      <Heading level={3}>{t("You've completed all the milestones!")}</Heading>
      <DarkButton
        iconName='home-small'
        trackingId={OnboardingDashboardTrackingIds.navigateToDashboard}
        onClick={() => navigate({ to: '/home/dashboard' })}
      >
        {t('Go to Dashboard')}
      </DarkButton>
    </div>
  );
};

export const TasksScheduledNavigation = () => {
  const { t } = useTranslation('onboardingDashboard');
  const navigate = useNavigate();
  return (
    <div css={[styles.container]}>
      <Text size='small' color='light'>
        {t("You're all set for now!")}
      </Text>
      <DarkButton iconName='home-small' onClick={() => navigate({ to: '/home/dashboard' })}>
        {t('Go to Dashboard')}
      </DarkButton>
      <Text size='small' color='light'>
        {t('All of your tasks are awaiting their scheduled dates')}
      </Text>
    </div>
  );
};

export const TrainingLinkNavigation = () => {
  const { t } = useTranslation('onboardingDashboard');
  return (
    <div css={styles.container}>
      <Text size='small' color='light' textAlign='center' css={{ maxWidth: 270 }}>
        {t('Ready to keep going? Check out Weave Training Camp to learn everything Weave has to offer!')}
      </Text>
      <DarkButton
        iconName='home-small'
        trackingId={OnboardingDashboardTrackingIds.trainingCampLink}
        onClick={() => window.open(TRAINING_LINK, '_blank', 'noopener noreferrer')}
      >
        {t('Weave Training Camp')}
      </DarkButton>
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(1)};
    align-items: center;
  `,
};
